export default "__VITE_ASSET__cd13869c__"